$(document).ready(function () {
    // Initial check
    checkAnimateInElements();

    // Check on scroll
    $('body, html').on('scroll orientationchange', function () {
        checkAnimateInElements();
    });

    $(window).on('scroll orientationchange', function () {
        checkAnimateInElements();
    });
});

// Function to check if an element is in the viewport
function isElementInView(element) {
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
}

// Check .js-animate-in elements for visibility with staggered effect
function checkAnimateInElements() {
    var delayTime = 0; // Start with no delay for the first element

    $('.js-animate-in').not('.visible').each(function () {
        var element = $(this); // Current .js-animate-in element

        // Only apply the effect if the element is in view and doesn't already have the 'visible' class
        if (isElementInView(element) && !element.hasClass('visible')) {
            setTimeout(function () {
                element.addClass('visible');
            }, delayTime);

            // Increment the delay for the next element
            delayTime += 200; // Adjust this value as needed for the delay between elements
        }
    });
}